import {Injectable} from "ng-metadata/core";
import {ConfigurationUtil} from "../../../../../nddUtils/configurationUtil.service";
const groupBy = require('lodash/groupBy');

@Injectable()
export class ActiveFacetsMergeLocationFacetsWithinSingleLibraryService{
    constructor(private configurationUtil: ConfigurationUtil){
    }


    public transform(facetsList){
        if(!this.configurationUtil.isSuprima()){
            return facetsList;
        }
        let locationFacetRegex = /(.+)–(.+)–(.+)/;
        let groups = groupBy(facetsList, (facet)=> {
            if (facet.name === 'location_code'){
                let match = locationFacetRegex.exec(facet.value);
                if (match){
                    return match[2] + facet.label ; //group by displayed label and library code
                }
                else{
                    return 'ungrouped';
                }
            }
            else{
                return 'ungrouped';
            }
        });
        facetsList = [];
        for (let key in groups){
            if (key === 'ungrouped'){
                facetsList = facetsList.concat(groups[key]);
            }
            else if (groups[key].length > 1){
                let facet = groups[key][0];
                facet.mergedFacets = groups[key].slice(1);
                facetsList.push(facet);
            }
            else{
                facetsList = facetsList.concat(groups[key]);
            }
        }
        return facetsList;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/facet/facetsTransformation/activeFacetsTransformations/activeFacetsMergeLocationFacetsWithinSingleLibrary/activeFacetsMergeLocationFacetsWithinSingleLibrary.service.ts